// extracted by mini-css-extract-plugin
export var menuIcon = "_si-0";
export var menuIconInline = "_si-1";